import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
import 'arrive';

import { CLASSES } from '../_consts';

export default function rangeSlider() {
  const onlyDigitsRegx = /^\d*\.?\d*$/;

  window.initRangeSlider = (initStart, initFinish) => {
    const slider = document.querySelector('.js-range-slider');
    if (slider) {
      const start = +slider.dataset.rangeStart;
      const finish = +slider.dataset.rangeFinish;
      const output = document.querySelector('.js-range-value');
      const rangeWrapper = document.querySelector('.js-range-fields');
      const startInput = rangeWrapper.querySelector('.js-range-start');
      const endInput = rangeWrapper.querySelector('.js-range-end');
      const btn = rangeWrapper.querySelector('.js-range-btn');
      const { isDisabled, isError } = CLASSES;

      // eslint-disable-next-line no-inner-declarations
      function onInput(e) {
        const target = e.currentTarget;
        const { value } = target;
        if (!onlyDigitsRegx.test(value) || value < start || value > finish) {
          btn.classList.add(isDisabled);
          startInput.classList.add(isError);
          endInput.classList.add(isError);
        } else {
          btn.classList.remove(isDisabled);
          startInput.classList.remove(isError);
          endInput.classList.remove(isError);
          const startVal = target.dataset.range === 'start' && value;
          const endVal = target.dataset.range === 'end' && value;
          slider.noUiSlider.set([startVal, endVal]);
        }
      }

      noUiSlider.create(slider, {
        start: [start, finish],
        connect: true,
        range: {
          'min': [start],
          'max': [finish]
        },
        format: wNumb({
          decimals: 0,
          thousand: ' ',
        })
      });

      slider.noUiSlider.set([initStart, initFinish]);

      slider.noUiSlider.on('update', (values) => {
        output.innerHTML = values.join(' - ');
        btn.classList.remove(isDisabled);
        startInput.classList.remove(isError);
        endInput.classList.remove(isError);
        startInput.value = parseInt(values[0].replace(/ /g, ''), 10);
        endInput.value = parseInt(values[1].replace(/ /g, ''), 10)
      });


      startInput.addEventListener('input', onInput);
      endInput.addEventListener('input', onInput);
    }
  };

  window.initRangeSlider();
}
